module.exports = __webpack_public_path__ + "img/step1.09413317.png";